import { motion } from "framer-motion";
import { ConversationCard } from "./ConversationCard";

export const ConversationsList = ({
  conversations,
  userRole,
  onConversationClick
}) => {
  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: { type: "spring", stiffness: 100 }
    }
  };

  return (
    <motion.div variants={itemVariants} className="space-y-4">
      {conversations.map((conversation) => (
        <ConversationCard
          key={`${conversation?.id}`}
          conversation={conversation}
          userRole={userRole}
          onClick={onConversationClick}
        />
      ))}
    </motion.div>
  );
};
